import { AllowedHostsModel } from '_/models/allowedHosts';
import { getDb } from './SqliteDatabase';

// Inicializa a tabela no banco de dados, caso ainda não exista.
const init = async () => {
  const db = getDb();
  await db.execAsync(`
    CREATE TABLE IF NOT EXISTS allowed_hosts_table (
      id TEXT NOT NULL,
      cardNumber TEXT NOT NULL,
      source_name TEXT NOT NULL,
      eventdatetime TIMESTAMP NOT NULL,
      eventhwid INTEGER NOT NULL,
      PRIMARY KEY (id)
    );
  `);
};

// Cria um novo registro na tabela de hosts permitidos
const create = async (allowedHost: AllowedHostsModel) => {
  const db = getDb();
  await db.withTransactionAsync(async (txn) => {
    await txn.executeSqlAsync(
      'INSERT INTO allowed_hosts_table (id, cardNumber, source_name, eventdatetime, eventhwid) VALUES (?, ?, ?, ?, ?);',
      [
        allowedHost.id,
        allowedHost.cardNumber,
        allowedHost.source_name,
        `${allowedHost.eventdatetime}`,
        allowedHost.eventhwid,
      ]
    );
  });
};

// Deleta um registro específico de host permitido com base no id e source_name
const deleteOne = async (id: string, source_name: string) => {
  const db = getDb();
  await db.withTransactionAsync(async (txn) => {
    await txn.executeSqlAsync('DELETE FROM allowed_hosts_table WHERE id = ? AND source_name = ?;', [
      id,
      source_name,
    ]);
  });
};

// Recupera todos os hosts permitidos da tabela
const all = async (): Promise<AllowedHostsModel[]> => {
  const db = getDb();
  const allowedHosts: AllowedHostsModel[] = [];

  await db.withTransactionAsync(async (txn) => {
    const { rows } = await txn.executeSqlAsync('SELECT * FROM allowed_hosts_table;', []);
    for (let i = 0; i < rows.length; ++i) {
      const item = rows.item(i);
      allowedHosts.push(item);
    }
  });

  return allowedHosts;
};

// Deleta a tabela inteira
const deleteTable = async () => {
  const db = getDb();
  await db.execAsync(`
    DROP TABLE IF EXISTS allowed_hosts_table;
  `);
};

export default {
  create,
  all,
  deleteTable,
  deleteOne,
  init,
};
